/// <reference path="../membershipManager.module.ts" />
/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.MembershipManager {

    import ICancellationDates = Meevo.Components.Common.ICancellationDates;

    export interface ICancellationParams {
        cancellationState: Meevo.Model.ClientMembershipCancellationStateEnum
        cancelledDate: Date,
        terminationDate: Date,
        accruedServiceExpireDate: Date,
        membershipCancellationId: string,
        isImmediateCancelled: boolean
    }

    class CancellationModalController {

        static $inject = [
            "$scope",
            "$mdDialog",
            "membership",
            "cancellationDatesSettings",
            "$translate",
            "$q",
            "$timeout",
            "meevo.components.common.ClientMembershipDataService",
            "meevo.components.common.SecurityService",
            "meevo.components.busy.BusyService",
            "meevo.AppSettings"
        ];

        public reasonList: Array<Meevo.Model.MembershipCancellation>;
        public isImmediateCancelled: boolean;
        public selectedReasonId: string;
        public accruedServiceExpireDate: Date;
        public showAccruedServicesExpiredDate: boolean;
        public today: Date;
        private _dates: ICancellationDates;
        private _cancellationDate: moment.Moment;
        private _terminationDate: moment.Moment;
        private _accruedServiceExpiration: moment.Moment;
        private accruedServiceExpirationFrom: Date;
        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        constructor(
            protected $scope: ng.IScope,
            protected $mdDialog: angular.material.IDialogService,
            protected membership: Meevo.Model.ClientMembership,
            protected cancellationDatesSettings: ICancellationDates,
            protected $translate: angular.translate.ITranslateService,
            protected $q: ng.IQService,
            protected $timeout: ng.ITimeoutService,
            protected dataService: Meevo.Components.Common.ClientMembershipDataService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected appSettings: Meevo.Components.Common.IAppSettings
        ) {
            busyService.start();
            $q.all([
                this.loadCancellationReasonList(),
                this.loadDates({ cancellationDate: membership.cancelledDate, terminationDate: membership.terminationDate}, true)
            ]).finally(() => {
                    busyService.stop();
                });

            this.isImmediateCancelled = membership.hasOwnProperty('cancellationState') && membership.cancellationState === Meevo.Model.ClientMembershipCancellationStateEnum.ImmediateCancellation;
            this.selectedReasonId = membership.hasOwnProperty('membershipCancellationId') ? membership.membershipCancellationId : undefined;
            this.cancellationDate = membership.hasOwnProperty('cancelledDate') ? membership.cancelledDate : undefined;
            this.terminationDate = membership.hasOwnProperty('terminationDate') ? membership.terminationDate : undefined;
            this.accruedServiceExpiration = membership.hasOwnProperty('accruedServiceExpireDate') ? membership.accruedServiceExpireDate : undefined;

            this.accruedServiceExpireDate = moment().startOf('day').toDate();
            this._dates = cancellationDatesSettings;

            this.today = new Date();
            this.today.setHours(0, 0, 0, 0);

            // watch changes on the ImmediateCancelled checkbox
            $scope.$watch(() => {
                return this.isImmediateCancelled;
            }, (newVal: boolean, oldVal: boolean) => {
                if (newVal !== oldVal) {
                    this.toggleImmediateCancellation(newVal);
                }
            })
        }

        private loadCancellationReasonList(): ng.IPromise<any> {
            return this.dataService.getListPaged(this.appSettings.API_ENDPOINTS.membershipCancellation, {
                criteria: {
                    objectState: Meevo.Model.ObjectStateEnum.Active
                }
            })
                .then((data: Array<Meevo.Model.MembershipCancellation>|any) => {
                    this.reasonList = data;
                });
        }

        /**
         * Get from server pre-calculated cancellation, termination and accrued service expiration dates
         * */
        private loadDates(requestData?, showLoading: boolean = false): ng.IPromise<any> {
            let guidId = new Guid(this.membership.id);
            
            return this.dataService.getDatesForCancellation(guidId, requestData)
                .then((data: ICancellationDates|any) => {
                    this._dates = data;

                    this.showAccruedServicesExpiredDate = data.accruedServiceExpireDate ? true : false;

                    if (this.isImmediateCancelled) {
                        this.toggleImmediateCancellation(this.isImmediateCancelled);
                        return true;
                    }

                    this.updateDateControlsData(requestData);
                });
        }

        apply = () => {
            /* Set Current Time to cancellation dates */
            let currentDate = new Date();

            this.cancellationDate.setHours(currentDate.getHours());
            this.cancellationDate.setMinutes(currentDate.getMinutes());

            this.terminationDate.setHours(currentDate.getHours());
            this.terminationDate.setMinutes(currentDate.getMinutes());

            this.accruedServiceExpiration.setHours(currentDate.getHours());
            this.accruedServiceExpiration.setMinutes(currentDate.getMinutes());


            let cancellationParams: ICancellationParams = {
                cancellationState: this.isImmediateCancelled ? Meevo.Model.ClientMembershipCancellationStateEnum.ImmediateCancellation : Meevo.Model.ClientMembershipCancellationStateEnum.Cancellation,
                cancelledDate: this.cancellationDate,
                terminationDate: this.terminationDate,
                accruedServiceExpireDate: this.showAccruedServicesExpiredDate ? this.accruedServiceExpiration : undefined,
                membershipCancellationId: this.selectedReasonId,
                isImmediateCancelled: this.isImmediateCancelled
            };
            let params = {
                cancellationParams: cancellationParams,
                cancellationDatesSettings: this._dates,
                showAccruedServicesExpiredDate: this.showAccruedServicesExpiredDate
            };

            this.$mdDialog.hide(params);
        };

        cancel = () => {
            this.$mdDialog.cancel();
        };

        public toggleImmediateCancellation(value: boolean): void {
            // if isImmediateCancelled then set all dates as today
            let immediateCancellationDate = moment().startOf('day');
            if (value) {
                this.dates.terminationDateFrom = immediateCancellationDate.clone().toDate();
                this.dates.cancellationDateFrom = immediateCancellationDate.clone().toDate();
                this.accruedServiceExpirationFrom = immediateCancellationDate.clone().toDate();
                
                // $timeout for update min/max date in datePicker
                this.$timeout(() => {
                    this._cancellationDate = immediateCancellationDate.clone();
                    this._terminationDate = immediateCancellationDate.clone();
                    this._accruedServiceExpiration = moment(this._dates.immediateCancellationAccruedServiceExpireDate);
                   
                });
            } else {
                // POST request for dates like new modal
                this.loadDates({}, true).then(() => {
                    this._cancellationDate = moment(this._dates.cancellationDateFrom);
                });
            }
        }

        public get dates(): ICancellationDates {
            return this._dates;
        }

        public get cancellationDate(): Date {
            return this._cancellationDate ? this._cancellationDate.toDate() : undefined;
        }

        public set cancellationDate(input: Date) {
            this._cancellationDate = moment(input);
        }

        public get terminationDate(): Date {
            return this._terminationDate ? this._terminationDate.toDate() : undefined;
        }

        public set terminationDate(input: Date) {
            this._terminationDate = moment(input);
        }

        public get accruedServiceExpiration(): Date {
            return this._accruedServiceExpiration ? this._accruedServiceExpiration.toDate() : undefined;
        }

        public set accruedServiceExpiration(input: Date) {
            this._accruedServiceExpiration = moment(input);
        }

        /**
         * Update cancellation, termination and accrued service expiration dates with data loaded from server
         * */
        private updateDateControlsData(requestData?): void {
            // $timeout for update min/max date in datePicker
            this.$timeout(() => {
                this._cancellationDate = requestData && requestData.cancellationDate ? this._cancellationDate : moment(this._dates.cancellationDateFrom);
                this._terminationDate = requestData && requestData.terminationDate ? this._terminationDate : moment(this._dates.terminationDateTill);
                this._accruedServiceExpiration = moment(this._dates.accruedServiceExpireDate);
                this.accruedServiceExpirationFrom = this._terminationDate.toDate();
            });
        }

        public changeCancellationDate(): void {
            this.loadDates({ cancellationDate: this.cancellationDate }, true);
        }

        public changeTerminationDate(): void {
            let requestData = {
                cancellationDate: this.cancellationDate,
                terminationDate: this.terminationDate
            };
            
            this.loadDates(requestData, true);
        }
    }

    angular.module("meevo.plugins.membershipManager")
        .controller("meevo.plugins.membershipManager.CancellationModalController", CancellationModalController);
}